import { ReactElement } from 'react'
import DangerousIcon from '@mui/icons-material/Dangerous'
import WarningIcon from '@mui/icons-material/Warning'
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material'

interface Props {
  problems: ProblemOnElement[]
}

const ElementProblemsList = ({ problems }: Props): ReactElement | null => {
  if (problems.length === 0) return null

  return (
    <List dense>
      {problems.map(({ message, severity }, index) => (
        <ListItem key={index}>
          <ListItemIcon>{severity === 'error' ? <DangerousIcon /> : <WarningIcon />}</ListItemIcon>
          <ListItemText primary={message} />
        </ListItem>
      ))}
    </List>
  )
}

export default ElementProblemsList
